import img from "../../../../assets/images/misc/social-impact-investment.jpg";

function SectionLayanan() {
    return (
        <section className="py-16" id="sectionProblems">
            <article className="relative max-w-container mx-auto px-6 md:px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="center-web">
                        <img src={img} alt="" className="w-full h-96 object-cover" />
                    </div>
                    <div className='self-start'>
                        <h2 className="font-bold text-[32px] leading-[130%] tracking-wider text-dark montserrat">
                            <span className="underlined">Social Impact Investment</span>
                        </h2>
                        <p className='text-base text-dark text-[16px] mt-4'>
                            Manajemen Pendanaan (Crowdfunding) perseorangan maupun CSR perusahaan yang akan di investasikan ke wirausaha sosial / bisnis sosial agar dampaknya semakin luas dan terus berkelanjutan
                        </p>
                    </div>
                </div>
            </article>
        </section>
    );
}

export default SectionLayanan;